<template>
  <card-item card="item_client" :tabs="tabs" v-model="activeTab"
    :id="`${id}${$store.state.user.sections['clients'] ? '' : '000030003'}`">
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key: 'info',
          component: () => import("./Info"),
        },
        // {
        //   title: "Поля для заполнений",
        //   key:'fields',
        //   component: () => import("./Cards"),
        // },
      ],
      activeTab: 0,
    };
  },
};
</script>